{
  "title": "Masters",
  "subtitle": "Core reference data shared across every transaction screen.",
  "noAccess": "You don't have access to any master data screens.",
  "tabs": {
    "company": "Company & Branch",
    "warehouses": "Warehouse & Location",
    "materials": "Materials",
    "categories": "Material Categories",
    "uom": "Units of Measure",
    "bom": "Bill of Materials",
    "suppliers": "Suppliers",
    "customers": "Customers",
    "carriers": "Carriers",
    "clients": "Clients",
    "clientContracts": "Client Contracts",
    "qcCheckpoints": "QC Checkpoints"
  }
}
